module.exports = __webpack_public_path__ + "static/media/edit.d95d62f3.svg";